import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';

import { CoreModule } from '@ridango/core';

import { ShoppingCartActions, ShoppingCartActionsV2, ShoppingCartEpics, ShoppingCartFacade } from './+state';
import { ShoppingCartService } from './shopping-cart.service';
import { ShoppingCartIconService } from './shopping-cart-icon.service';

@NgModule({
    imports: [CommonModule, CoreModule],
    declarations: [],
    providers: [
        DatePipe,
        ShoppingCartActions,
        ShoppingCartActionsV2,
        ShoppingCartEpics,
        ShoppingCartFacade,
        ShoppingCartService,
        ShoppingCartIconService
    ]
})
export class ShoppingCartModule {}
